import { cva } from '@/styled-system/css';

export const switchTrackRecipe = cva({
  base: {
    borderRadius: 'shape.capsule',
    display: 'inline-block',
    position: 'relative',
    userSelect: 'none',
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'all 0.4s ease 0s',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        _hover: {
          backgroundColor: 'Switch.Track.bg.hover',
        },
        _active: {
          backgroundColor: 'Switch.Track.bg.pressed',
        },
      },
    },
    checkedState: {
      true: {
        backgroundColor: 'bg.action.hero.selected.default',
      },
      false: {
        backgroundColor: 'Switch.Track.bg.default',
      },
    },
    size: {
      md: {
        height: 'action.xxs',
        width: 'Switch.Track.md.width',
      },
      lg: {
        height: 'Switch.Track.lg.height',
        width: 'Switch.Track.lg.width',
      },
    },
  },
  compoundVariants: [
    {
      checkedState: true,
      disabled: false,
      css: {
        _hover: {
          backgroundColor: 'bg.action.hero.selected.hover',
        },
        _active: {
          backgroundColor: 'bg.action.hero.selected.pressed',
        },
      },
    },
  ],
});
